import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';

export const EventRecordContextMenu = ({ contextMenu, closeContextMenu }) => {
  const { setShowEventRecordGroupMenu, eventRecord, setEventRecord, setSelectedEventGroup } = useAccomodationDiagram();

  const handleOpenEventRecordGroupDialog = () => {
    setSelectedEventGroup(null);
    setEventRecord(contextMenu.eventRecord);
    setShowEventRecordGroupMenu(true);
    closeContextMenu();
  };

  if (!eventRecord) {
    return null;
  }

  return (
    <Menu
      open={contextMenu !== null}
      onClose={closeContextMenu}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      <MenuItem onClick={handleOpenEventRecordGroupDialog}>Dodaj grupę</MenuItem>
    </Menu>
  );
};
